import { CreateContactDto } from './dto/create-contact.dto';
import { SharedContactService } from './../shared-contact.service';
import { trigger, transition, style, animate } from '@angular/animations';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  ContentChild,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  LearmoModalRef,
  LearmoModalService,
} from '../../../../shared/services/learmo-modal.service';

import { ApiService } from '../../../../shared/services/lsg.api.service';
import { MediaLibraryFileModel } from '../../../../models/sales-funnel';
import { lastValueFrom, take, takeWhile } from 'rxjs';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OnDestroy, AfterViewInit } from '@angular/core';
import { SharedProductService } from '../../product/shared-product.service';

import { Store } from '@ngrx/store';

import { ContactItem, ContactItemType } from '../models/contacts';
import { colorSet } from 'src/app/models/global-classes';
import {
  isCreateContactProcessing,
  selectContactsState,
} from 'src/app/shared/store/_features/contacts/contacts.selector';
import { NewContactActions } from 'src/app/shared/store/_features/contacts/contacts.actions';
import { AnimatedLoaderType } from 'src/app/shared/models/animated-loader-type.enum';

export interface UiContactType {
  name: string;
  description: string;
  value: ContactItemType;
  iconSvg: string;
  iconFont: string;
  iconColor: colorSet;
}
@Component({
  selector: 'app-contact-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ContactCreateComponent
  implements OnInit, OnDestroy, AfterViewInit {
  animatedLoaderType = AnimatedLoaderType;
  processing: boolean = false;
  // @Input() customAction = false;
  modalRef: LearmoModalRef;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalFooter') modalFooter: TemplateRef<any>;
  @Input() includeThisProduct: number;
  @Input() setThisPortal: number;
  @Input() editContact: ContactItem | null = null;

  @Output() onCreateDone = new EventEmitter<ContactItem>();
  @Output() onUpdateDone = new EventEmitter<ContactItem>();
  // loading: { currencies: boolean; portals: boolean } = {
  //   currencies: true,
  //   portals: true,
  // };

  currentContactType: UiContactType;
  contactsTypes: UiContactType[] = [
    {
      name: 'Instructor',
      description: 'Identifies educators responsible for course content.',
      value: 'instructor',
      iconSvg: '',
      iconFont: 'user-round',
      iconColor: 'primary',
    },
    {
      name: 'Lead',
      description:
        'Used in email automation to convert leads to enrolled students.',
      value: 'lead',
      iconSvg: '',
      iconFont: 'filter',
      iconColor: 'danger',
    },
    {
      name: 'Student',
      description:
        'You can add a student and grant him access to specific products.',
      value: 'student',
      iconSvg: '',
      iconFont: 'book-open',
      iconColor: 'success',
    },
    {
      name: 'Owner',
      description: 'Account Owner (You).',
      value: 'owner',
      iconSvg: '',
      iconFont: 'shield-check',
      iconColor: 'primary',
    },
  ];

  contactType: ContactItemType;

  @Input('contactType') set setContactType(value: ContactItemType) {
    this.contactType = value;
    // this.createContactForm.patchValue({type: value});
  }

  // Form Variables
  createContactForm = new FormGroup({
    name: new FormControl('', {
      updateOn: 'change',
    }),
    title: new FormControl('', {
      updateOn: 'change',
    }),
    bio: new FormControl('', {
      updateOn: 'change',
    }),
    email: new FormControl('', {
      validators: [Validators.email],
      updateOn: 'change',
    }),
    avatar: new FormControl([], {
      updateOn: 'change',
    }),
    avatar_id: new FormControl([], {
      updateOn: 'change',
    }),
    type: new FormControl('', {
      validators: [Validators.required],
      updateOn: 'change',
    }),
  });

  // Warning state
  showPayloadAvatarWarning: boolean = false;

  // NEW: explicit "user intentionally cleared the avatar" flag.
  // This is the single source of truth for whether the avatar should be
  // cleared on submit — it is NOT inferred from empty-array truthiness,
  // which was the root cause of the original bug.
  avatarRemoved: boolean = false;

  constructor(
    public modalService: LearmoModalService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private sharedProductService: SharedProductService,
    private store: Store,
    private sharedContactService: SharedContactService,
  ) {
    this.store.select(isCreateContactProcessing).subscribe((process) => {
      this.processing = process.status == 'creating';
      if (this.modalRef) {
        this.modalRef.setLoading(this.processing);
      }
    });

    this.createContactForm.controls.type.valueChanges.subscribe((value) => {
      const currentType = this.contactsTypes.find((a) => a.value === value);
      this.currentContactType = currentType;

      if (this.modalRef) {
        this.modalRef.setTitle(
          !value ? 'Select Contact Type' : 'Fill Contact Information',
        );
      }
    });
    this.createContactForm.valueChanges.subscribe((value) => { });
  }
  ngAfterViewInit(): void { }
  ngOnDestroy(): void { }

  async ngOnInit() {
    // await this.sharedOfferService.getProducts();
    if (this.editContact) {
      // this.lockForType = true;
      this.contactType = this.editContact.type;

      // Check if avatar is synced from Payload (has id=0)
      if (
        this.editContact.avatar &&
        this.editContact.avatar.length > 0 &&
        this.editContact.avatar[0].id === 0
      ) {
        this.showPayloadAvatarWarning = true;
      }
    }

    // Listen for avatar changes to:
    //  1) show the "synced avatar" warning (existing behavior)
    //  2) detect explicit removal vs. replacement vs. untouched (fix)
    this.createContactForm
      .get('avatar')
      ?.valueChanges.subscribe((newValue) => {
        const hadExistingAvatar =
          !!this.editContact?.avatar && this.editContact.avatar.length > 0;
        const isNowEmpty = !newValue || newValue.length === 0;

        if (hadExistingAvatar && isNowEmpty) {
          // User clicked Remove on a previously-existing avatar.
          this.avatarRemoved = true;
          // Prevent avatar_id from smuggling the stale id back into the
          // update payload (this was the original source of the bug).
          this.createContactForm
            .get('avatar_id')
            ?.setValue([], { emitEvent: false });
        } else if (!isNowEmpty) {
          // A new image was selected — removal no longer applies.
          this.avatarRemoved = false;
        }

        if (this.showPayloadAvatarWarning && newValue?.length > 0) {
          // User is trying to change the avatar synced from Payload
          // this.toastr.warning(
          //   'This avatar was set by the Contact from the Creator Website. Changing it here will override their preference.',
          //   'Warning: Synced Avatar',
          //   { timeOut: 5000 },
          // );
        }
      });
  }

  // Function to set up conditional validation

  closeModal() {
    if (this.processing) {
      this.toastr.warning('Wait until processing is finished');
    } else {
      this.modalRef.dismiss();
    }
  }

  resetContactType() {
    this.createContactForm.get('type').patchValue(null);
  }

  openModalProcess() {
    this.open();
  }
  // updatePrice(formGroup: FormGroup) {
  //   this.createContactForm.get('payment_type.price').patchValue(formGroup.value)
  //   // this.createContactForm.get('payment_type.price').setValue(eventValue);
  // }

  async createNewContact() {
    if (this.editContact) {
      await this.updateContact();
      return;
    }

    const createPayload: CreateContactDto = new CreateContactDto({
      name: this.createContactForm.value.name ?? undefined,
      title: this.createContactForm.value.title ?? undefined,
      bio: this.createContactForm.value.bio ?? undefined,
      avatar:
        this.createContactForm.value.avatar ??
        (this.createContactForm.value.avatar_id?.[0]
          ? [this.createContactForm.value.avatar_id[0]]
          : undefined),
      email: this.createContactForm.value.email ?? undefined,
      type: (this.createContactForm.value.type as ContactItemType) ?? undefined,
    });
    this.createContactForm.markAllAsTouched();

    if (!!this.createContactForm.valid) {
      this.store.dispatch(NewContactActions.create({ createPayload }));
      this.store
        .select(selectContactsState)
        .pipe(
          takeWhile(
            (state) =>
              state?.createNewContactProcess.status !== 'done' &&
              state?.createNewContactProcess.status !== 'error',
            true,
          ),
        )
        .subscribe((state) => {
          switch (state?.createNewContactProcess.status) {
            case 'done':
              this.onContactCreateDone(
                state.createNewContactProcess.lastCreatedContact,
              );
              break;
            case 'error':
              this.onContactCreateError(state.createNewContactProcess.error);
              break;
            default:
              break;
          }
        });
    }
  }

  async updateContact() {
    // Resolve the avatar value to send:
    //  - explicit removal -> null (tells the backend to CLEAR the reference,
    //    as opposed to `undefined`, which means "field not provided / leave
    //    as-is"). Never fall back to avatar_id here — that fallback was
    //    exactly what let the stale image survive the update before.
    //  - new image selected / untouched original avatar -> the array itself
    //  - only an avatar_id present (no full avatar objects) -> wrap it
    //  - nothing at all -> undefined (don't touch the field)
    const formAvatar = this.createContactForm.value.avatar;
    const formAvatarId = this.createContactForm.value.avatar_id;

    let avatarPayload: MediaLibraryFileModel[] | number[] | null | undefined;

    if (this.avatarRemoved) {
      avatarPayload = null;
    } else if (formAvatar && formAvatar.length > 0) {
      avatarPayload = formAvatar;
    } else if (formAvatarId && formAvatarId.length > 0) {
      avatarPayload = [formAvatarId[0]];
    } else {
      avatarPayload = undefined;
    }

    const payload = {
      name: this.createContactForm.value.name,
      title: this.createContactForm.value.title,
      bio: this.createContactForm.value.bio,
      email: this.createContactForm.value.email,
      avatar: avatarPayload,
      type:
        (this.createContactForm.value.type as ContactItemType) ||
        this.editContact.type,
    };

    this.sharedContactService.updateContact(
      this.editContact.id,
      payload,
      this.editContact.type,
    );

    // Subscribe to store to get the full updated contact response
    this.store
      .select(selectContactsState)
      .pipe(
        takeWhile(
          (state) =>
            state?.updateContactProcess.status !== 'done' &&
            state?.updateContactProcess.status !== 'error',
          true,
        ),
      )
      .subscribe((state) => {
        switch (state?.updateContactProcess.status) {
          case 'done':
            this.toastr.success('Done!', 'Contact Updated Successfully');
            this.closeModal();
            // Emit the full, fresh updated contact from the backend
            // (includes stats and extraData). With the avatar now cleared
            // server-side, `updatedContact.avatar` will be null/empty, so
            // any consumer rendering `app-initial-avatar` on a falsy avatar
            // will automatically fall back to showing initials.
            this.onUpdateDone.emit(state.updateContactProcess.updatedContact);
            this.avatarRemoved = false;
            break;
          case 'error':
            this.toastr.error('Failed to update contact');
            break;
          default:
            break;
        }
      });
  }

  onContactCreateDone = (contact: ContactItem) => {
    // this.route.navigate(['dashboard', 'product']);
    this.closeModal();
    this.onCreateDone.emit(contact);

    this.toastr.success('Done!', 'Contact Added Successfully', {
      closeButton: false,
      positionClass: 'toast-bottom-right',
    });
  };

  onContactCreateError = (error) => {
    this.toastr.error(error.message);
  };

  resetForm() {
    this.processing = false;
    this.avatarRemoved = false;
    if (!!this.contactType) {
      this.createContactForm.reset(
        { type: this.contactType },
        { emitEvent: true },
      );
    } else {
      this.createContactForm.reset(undefined, { emitEvent: false });
    }
  }

  async afterOpenModal() {
    // await this.sharedOfferService.getProducts();
    // await this.sharedOfferService.getUserPortals();
    // await this.sharedOfferService.getCurrencies();
  }

  async onOpenModal() {
    this.resetForm();
    if (this.editContact) {
      this.createContactForm.patchValue({
        name: this.editContact.name || '',
        title: this.editContact.title || '',
        bio: this.editContact.bio || '',
        email: this.editContact.email || '',
        type: this.editContact.type,
        // Normalize null/undefined to [] — MediaLibraryComponent's
        // @Input() selectedFiles expects an array and its default value
        // (`= []`) is only used before Angular sets a binding. Binding a
        // literal null here (e.g. avatar-less contact) would overwrite
        // that default and crash onRemoveFile()'s .filter() call.
        avatar: this.editContact.avatar ?? [],
      });
    }
  }

  async open() {
    await this.onOpenModal();
    const isTypeSelected = !!this.createContactForm?.value?.type;

    this.modalRef = this.modalService.open(this.modalContent, {
      title: !isTypeSelected
        ? 'Select Contact Type'
        : 'Fill Contact Information',
      icon: 'user-plus',
      size: 'lg',
      loading: this.processing,
      footer: this.modalFooter, // Pass dynamic footer
      premium: true,
    });

    this.modalRef.result.then(
      (result) => {
        this.resetForm();
      },
      (reason) => {
        this.resetForm();
      },
    );

    await this.afterOpenModal();
  }
}